/*
 * @Author: 317473294@qq.com
 * @Date: 2023-05-29 16:06:32
 * @LastEditTime: 2024-07-08 11:12:26
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/utils/time.js
 */
/**示例
 * const timestamp = 1627731495000; // 时间戳（单位为毫秒）
const dateString = timestampToDateString(timestamp);
console.log(dateString); // 输出 "2021-07-31 21:51:35" 
*/
//时间戳转时间
export function timestampToDateString(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const dateString = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    return dateString;
  }

//时间转时间戳
/**示例
 * const dateString = '2021-07-31 21:51:35'; // 日期字符串
const timestamp = dateStringToTimestamp(dateString);
console.log(timestamp); // 输出 1627731495000
*/
export function dateStringToTimestamp(dateString) {
    const timestamp = Date.parse(dateString);
    return timestamp;
  }
  //获取当前时间
  export function getCurrentDateTime() {  
    const date = new Date(); // 创建Date对象表示当前时间  
    const year = date.getFullYear(); // 获取年份  
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 获取月份（加1因为月份是从0开始的），并格式化为两位数  
    const day = String(date.getDate()).padStart(2, '0'); // 获取日期，并格式化为两位数  
    const hours = String(date.getHours()).padStart(2, '0'); // 获取小时，并格式化为两位数  
    const minutes = String(date.getMinutes()).padStart(2, '0'); // 获取分钟，并格式化为两位数  
    const seconds = String(date.getSeconds()).padStart(2, '0'); // 获取秒，并格式化为两位数  
  
    // 组合成完整的日期时间字符串  
    const dateTimeString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
    return dateTimeString;  
}
//格式化时间
export function formatDate(dateStr) {  
  const date = new Date(dateStr);  
  const year = date.getFullYear();  
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的  
  const day = String(date.getDate()).padStart(2, '0');  
  const hours = String(date.getHours()).padStart(2, '0');  
  const minutes = String(date.getMinutes()).padStart(2, '0');  
  const seconds = String(date.getSeconds()).padStart(2, '0');  

  // 构建新的日期时间字符串  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
}


// WEBPACK FOOTER //
// ./src/utils/time.js